import React from "react";

function CultureofficeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M8.011 1c.167 0 .354.042.511.143l.076.056 7.092 6.378.07.067c.153.16.24.336.24.53l-.005.085c0 .48-.369.864-.806.907l-.083.005h-.889l.02 4.548-.003.115c-.054.917-.769 1.65-1.663 1.708l-.112.004h-8.9l-.113-.004c-.892-.057-1.606-.788-1.662-1.7l-.004-.115V9.171H.89l-.087-.005A.892.892 0 010 8.26c0-.224.064-.426.21-.606l.068-.076L7.4 1.227l.074-.066C7.65 1.02 7.841 1 8.011 1zm2.878 6.364a1.546 1.546 0 00-2.136-.082l-.086.082L8 8.046l-.666-.682-.086-.082a1.546 1.546 0 00-2.137.082 1.633 1.633 0 00-.08 2.184l.08.088 2.575 2.634.055.048a.44.44 0 00.518 0l.055-.048 2.575-2.634.08-.088a1.633 1.633 0 00-.08-2.184z"
        ></path>
      </g>
    </svg>
  );
}

export default React.memo(CultureofficeIcon);
